import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rgi-scholarship',
  templateUrl: './rgi-scholarship.component.html',
  styleUrls: ['./rgi-scholarship.component.scss']
})
export class RgiScholarshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
